import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  AddSaleOrderNote,
  EditSaleOrderNote,
  GetAllSaleOrderNotes,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextInputField from "../../components/TextInputField";
import TextAreaField from "../../components/TextAreaField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import SelectField from "../../components/SelectField";

const AddEditSaleOrderNote = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    saleordernote: "select",
    title: "",
    notes: "",
  });
  const [saleOrderNotes, setSaleOrderNotes] = useState([]);
  const [mode, setMode] = useState("ADD"); // "ADD" or "EDIT"
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Users");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({
        ...prev,
        [e.name]: option,
        notes: option.notes,
        title: option.label,
      }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoading(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (
        key === "title" ||
        key === "notes" ||
        (key === "saleordernote" && mode === "EDIT")
      ) {
        const error = validateField(key, formData[key], key);
        if (error) newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoading(false);
      return;
    }
    try {
      if (mode === "ADD") {
        const response = await AddSaleOrderNote(formData.title, formData.notes);
        if (response.success) {
          showSuccessToast("Success!", "Sale Order Note added successfully!");
          window.location.reload();
        } else
          showErrorToast(
            "Error!",
            "Sale Order Note failed to add!\n\n" + response.message,
          );
      } else {
        const response = await EditSaleOrderNote(
          formData.saleordernote.value,
          formData.title,
          formData.notes,
        );
        if (response.success) {
          showSuccessToast("Success!", "Sale Order Note updated successfully!");
          window.location.reload();
        } else
          showErrorToast(
            "Error!",
            "Sale Order Note failed to update!\n\n" + response.message,
          );
      }
    } catch (err) {
      showErrorToast("Error!", "Sale Order Note failed to add!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      TimeoutUtility.resetTimeout();
      await GetAllSaleOrderNotes()
        .then((resp) => {
          const cmpOptions = resp.data.map((item) => ({
            label: item.title,
            notes: item.notes,
            value: item.note_id,
          }));
          setSaleOrderNotes(cmpOptions || []);
        })
        .catch((err) => console.log(err.message));
    }
    fetchData();
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <div className="flex w-100% items-center justify-between">
        <Header title={`${mode} SALE ORDER NOTE`} />
        <Button
          text={mode === "ADD" ? "Update Old" : "Add New"}
          onClick={() => {
            setMode(mode === "ADD" ? "EDIT" : "ADD");
          }}
          disabled={loading}
        />
      </div>
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={8} className="container-col">
              <div className="col-lg-12">
                {mode === "EDIT" && (
                  <SelectField
                    label="Sale Order Note:"
                    name="saleordernote"
                    value={formData.saleordernote}
                    onChange={handleSelectChange}
                    options={saleOrderNotes}
                    placeholder="Select Sale Order Note"
                    compulsory={true}
                    error={errors.saleordernote}
                  />
                )}
                <TextInputField
                  label="Title:"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="Title"
                  compulsory={true}
                  error={errors.title}
                />
                <TextAreaField
                  label="Notes:"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Notes"
                  compulsory={true}
                  error={errors.notes}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text={mode === "ADD" ? "Add" : "Update"}
          onClick={handleSubmit}
          disabled={loading}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddEditSaleOrderNote;
